/**
 * Copyright © 2026 Adnuntius AS.
 */
import {ChangeDetectionStrategy, Component, Input} from '@angular/core';

import template from './line-item-template-analysis-page.component.html';
import {ADVERTISING_SHARED} from '../advertising/advertising-shared';
import {LineItemModel} from './line-item-api.service';
import {SignalAdminResourcePageState} from '../common/controller/signal-admin-resource-page-state';

@Component({
  standalone: true,
  imports: [...ADVERTISING_SHARED],
  selector: 'adn-line-item-template-analysis-page',
  template,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LineItemTemplateAnalysisPageComponent {
  private pageState: SignalAdminResourcePageState<LineItemModel>;
  notesSaveTarget: any;

  @Input()
  set state(value: SignalAdminResourcePageState<LineItemModel>) {
    this.pageState = value;
    this.notesSaveTarget = value?.notesSaveTarget();
  }

  get state(): SignalAdminResourcePageState<LineItemModel> {
    return this.pageState;
  }

  get model(): LineItemModel {
    return this.state?.model();
  }

  get effectiveIsNew(): boolean {
    return this.state?.isNew() ?? false;
  }

  get lineItemTemplate(): LineItemModel {
    return this.model;
  }

  get apiModel(): LineItemModel {
    return this.model;
  }

  get readOnly(): boolean {
    return this.state?.readOnly() ?? true;
  }

}
